import { CreateCampaignContext, PageResultType, pageSteps, PageStepType } from '~/contexts/CreateCampaignContext'
import React, { useContext, useEffect, FC, useState } from 'react'
import { getEventClient } from '~/lib/event'
import { CreateMethod } from './CreateMethod'
import { StoreInfo } from './StoreInfo'
import { ServiceContents } from './ServiceContents'
import { Confirmation } from './Confirmation'
import { CreateSuccess } from './CreateSuccess'
import { CreateFailure } from './CreateFailure'
import { InfluencerContactInfo } from './InfluencerContactInfo'
import { SnsContents } from './SnsContents'
import { GrossContents } from './GrossContents'
import { ReservationScheduleContents } from './ReservationScheduleContents'
import { PublishSettings } from './PublishSettings'
import { HomeButtons } from '~/features/campaign_create/HomeButton'
import { ExpenseSetting } from './ExpenseSetting'
import { StartGuideButton } from '~/components/common/StartGuideButton'
import { useMediaQuery } from '@mui/material'
import { theme } from '~/lib/theme'

const components = {
  [pageSteps.createMethod]: <CreateMethod />,
  [pageSteps.storeInfo]: <StoreInfo />,
  [pageSteps.serviceContents]: <ServiceContents />,
  [pageSteps.influencerContactInfo]: <InfluencerContactInfo />,
  [pageSteps.grossContents]: <GrossContents />,
  [pageSteps.snsContents]: <SnsContents />,
  [pageSteps.reservationScheduleContents]: <ReservationScheduleContents />,
  [pageSteps.expenseSettings]: <ExpenseSetting />,
  [pageSteps.publishSettings]: <PublishSettings />,
  [pageSteps.confirmation]: <Confirmation />,
} satisfies Record<PageStepType, React.JSX.Element>

const results = {
  create_failure: <CreateFailure />,
  create_success: <CreateSuccess />,
} satisfies Record<PageResultType, React.JSX.Element>

export const Create: FC = () => {
  const { pageStep, pageResult, sessionId } = useContext(CreateCampaignContext)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const showGuide =
    (pageStep !== pageSteps.confirmation && !isMobile) || (pageStep === pageSteps.createMethod && isMobile)
  const [hasSentCreateEvent, setHasSentCreateEvent] = useState(false)

  // 初回レンダリング時にキャンペーン作成イベントを送信
  useEffect(() => {
    if (!hasSentCreateEvent) {
      getEventClient().sendCampaignCreate({
        custom: {
          session_id: sessionId,
        },
      })
      setHasSentCreateEvent(true)
    }
  }, [sessionId, hasSentCreateEvent])

  // pageStepが変わるたびに、スクロール位置をリセットする
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pageStep, pageResult])
  return (
    <>
      {!pageResult ? (
        <>
          {showGuide && <StartGuideButton variant="outlined" absolutePositionTopRight forceShowLabel />}
          {pageStep && components[pageStep]}
          <HomeButtons />
        </>
      ) : (
        results[pageResult]
      )}
    </>
  )
}
